module.exports = __webpack_public_path__ + "img/readiness_score.39666814.svg";